/*
 *   File : view-template.js
 *   Author : https://evoqins.com
 *   Description : view template modal component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import parse from 'html-react-parser';

//Custom components
import { Icon } from '../Icon';

const ViewTemplateModal = (props) => {

    // handle close modal
    const _handleCloseModal = () => {
        var button = document.getElementById("view-template-modal-close");
        button.click();
        props.handleClose();

    };

    return (
        <div className="modal fade"
            id="view-template-modal"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="sendReportModalLabel"
            aria-hidden="true">

            <div className={`modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable border-radius-28 e-view-temp-modal`}>
                <span id='view-template-modal-close' className='d-none' data-bs-dismiss="modal"></span>
                <div className="modal-content border-radius-28 overflow-hidden border-0 e-bg-white-dark pb-5">

                    {/* modal header */}
                    <div className="modal-header border-0 justify-content-between align-items-center padding-32px-lr padding-32px-top pb-4">
                        <h6 className='mb-0 e-text-chinese-black e-primary-font e-font-16 e-font-weight-600 line-height-24px'>
                            View template
                        </h6>
                        <Icon icon='close'
                            size="1.125rem"
                            className="d-flex cursor-pointer"
                            onClick={_handleCloseModal} />
                    </div>

                    {/* Modal body */}
                    <div className='modal-body pt-2 pb-2 padding-68px-lr'>
                        {/* {parse(props?.data?.html)} */}


                        <div style={{ margin: 'auto', background: '#FFFFFF', fontFamily: 'Arial, sans-serif' }}>
                            <div style={{ maxWidth: '610px', margin: 'auto', background: '#FFFFFF', position: 'relative', border: '1px solid #cccccc' }}>

                                <div style={{ width: '100%', background: '#7038D5' }} className='text-center py-3'>
                                    <img
                                        src="https://rayi-dev-static-assets.s3.ap-south-1.amazonaws.com/email-templates/logo.png"
                                        width="80"
                                        height="60"
                                        style={{ pointerEvents: 'none', objectFit: 'contain' }}
                                        alt="Rayi"
                                    />
                                </div>

                                <div style={{ width: '100%', padding: '24px', background: '#FFFFFF' }}>
                                    <h1 style={{
                                        fontWeight: 700,
                                        fontSize: '20px',
                                        lineHeight: '24px',
                                        color: '#000000',
                                        textAlign: 'center',
                                    }}>
                                        {props.data.title}
                                    </h1>

                                    <div className='text-center'>
                                        {props.data.image &&
                                            <img
                                                src={props.data.image}
                                                width="200"
                                                height="200"
                                                style={{ marginTop: '20px' }}
                                                className='object-fit-contain'
                                                alt="Illustration"
                                            />
                                        }
                                    </div>

                                    <p className='e-view-template-html-parser-data' style={{
                                        paddingBottom: '4px',
                                        paddingTop: '16px',
                                    }}>
                                        {parse(props?.data?.content)}
                                    </p>

                                    <div className='text-center '>
                                        {props.data.button_name &&
                                            <a
                                                href={props.data.redirection_link}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{
                                                    padding: '4px 22px',
                                                    background: '#E47B2B',
                                                    borderRadius: '100px',
                                                    border: 0,
                                                    fontWeight: 500,
                                                    fontSize: '14px',
                                                    lineHeight: '20px',
                                                    letterSpacing: '0.1px',
                                                    color: '#FFFFFF',
                                                    cursor: 'pointer',
                                                    textDecoration: 'none',
                                                    display: 'inline-block'
                                                }}
                                            >
                                                {props.data.button_name}
                                            </a>
                                        }
                                    </div>
                                </div>

                                <div style={{ width: '100%', padding: '0 24px', background: '#FFFFFF' }}>
                                    <p className='mb-2' style={{ fontWeight: 400, fontSize: '12px', paddingTop: '16px', lineHeight: '15px' }}>
                                        Warm Regards
                                    </p>
                                    <p className='mb-1' style={{
                                        fontWeight: 700,
                                        fontSize: '14px',
                                        lineHeight: '20px',
                                        letterSpacing: '0.1px'
                                    }}>
                                        Team Rayi
                                    </p>
                                    <a
                                        href="https://www.rayi.co.in"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className='e-text-blue-violet'
                                        style={{
                                            textDecoration: 'none',
                                            fontWeight: 400,
                                            fontSize: '12px',
                                            lineHeight: '15px'
                                        }}
                                    >
                                        www.rayi.co.in
                                    </a>
                                </div>

                                <div style={{ width: '100%', marginTop: "16px", padding: '24px', background: '#FFFFFF', textAlign: 'center', borderTop: '1px solid #313131', borderBottom: '1px solid #313131' }} >
                                    <p className='mb-2' style={{ fontWeight: 700, fontSize: '14px', lineHeight: '16px' }}>
                                        Hey there! Need support?
                                    </p>
                                    <p className='mb-2' style={{ fontWeight: 400, fontSize: '14px', lineHeight: '18px' }}>
                                        <a
                                            href="https://rayi.onelink.me/E0lV/8esjovh8?nav=support&nav_id=0"
                                            style={{ fontWeight: 700, color: '#7038D5', textDecoration: 'underline' }}
                                        >
                                            Click here
                                        </a> to contact our support team
                                    </p>
                                    <p className='mb-0' style={{ fontWeight: 400, fontSize: '12px', lineHeight: '16px' }}>
                                        Available: Monday to Friday | 9 AM - 6 PM IST
                                    </p>
                                </div>

                                <div style={{ width: '100%', padding: '24px 24px', background: '#FFFFFF' }} className='d-flex align-items-center justify-content-between' >
                                    <div>
                                        <a href="https://apps.apple.com/gb/app/rayi-mutual-funds-sip-app/id6744385471" target="_blank" rel="noopener noreferrer">
                                            <img src="https://rayi-strapi.s3.ap-south-1.amazonaws.com/appstore_82ac1ab79b.png" width="24" height="24" alt="Appstore" />
                                        </a>
                                        <a href="https://play.google.com/store/apps/details?id=com.rayi" target="_blank" rel="noopener noreferrer" style={{ marginLeft: '8px' }}>
                                            <img src="https://rayi-strapi.s3.ap-south-1.amazonaws.com/playstore_fdc0442768.png" width="24" height="24" alt="Playstore" />
                                        </a>
                                        <a href="https://rayi.co.in/" target="_blank" rel="noopener noreferrer" style={{ marginLeft: '8px' }}>
                                            <img src="https://rayi-strapi.s3.ap-south-1.amazonaws.com/dribble_99e9f4d72b.png" width="24" height="24" alt="Dribble" />
                                        </a>
                                    </div>
                                    <div>
                                        <a href="https://www.instagram.com/rayi.co.in?igsh=MXZyZnplMGI2dG5rdA==" target="_blank" rel="noopener noreferrer">
                                            <img src="https://rayi-strapi.s3.ap-south-1.amazonaws.com/instagram_updated_188c589300.png" width="24" height="24" alt="Instagram" />
                                        </a>
                                        <a href="https://www.linkedin.com/company/rayi/" target="_blank" rel="noopener noreferrer" style={{ marginLeft: '8px' }}>
                                            <img src="https://rayi-strapi.s3.ap-south-1.amazonaws.com/linkedin_updated_e38166ed8e.png" width="24" height="24" alt="LinkedIn" />
                                        </a>
                                    </div>
                                </div>

                                <div style={{ width: '100%', padding: '24px', background: '#FAF8FF' }} className='d-flex align-items-center justify-content-between'>
                                    <div className='text-center'>
                                        <img src="https://rayi-strapi.s3.ap-south-1.amazonaws.com/goal_based_invest_d2a683320f.png" width="36" height="36" alt="Goal based invest" />
                                        <h6 style={{ paddingTop: '4px', textWrap: 'nowrap', color: '#000000', fontSize: '12px', lineHeight: '14px', fontWeight: 600 }}>
                                            Goal Based Investing
                                        </h6>
                                    </div>
                                    <div className='text-center'>
                                        <img src="https://rayi-strapi.s3.ap-south-1.amazonaws.com/smart_basket_abc84bdf98.png" width="40" height="34" alt="Smart Basket" />
                                        <h6 style={{ paddingTop: '4px', color: '#000000', fontSize: '12px', lineHeight: '14px', fontWeight: 600 }}>
                                            Smart Basket
                                        </h6>
                                    </div>
                                    <div className='text-center'>
                                        <img src="https://rayi-strapi.s3.ap-south-1.amazonaws.com/gold_maxx_838c90b50c.png" width="52" height="36" alt="Gold Maxx" />
                                        <h6 style={{ paddingTop: '4px', color: '#000000', fontSize: '12px', lineHeight: '14px', fontWeight: 600 }}>
                                            Gold Maxx
                                        </h6>
                                    </div>
                                    <div className='text-center'>
                                        <img src="https://rayi-strapi.s3.ap-south-1.amazonaws.com/instasave_5446543926.png" width="36" height="36" alt="Insta Save" />
                                        <h6 style={{ paddingTop: '4px', color: '#000000', fontSize: '12px', lineHeight: '14px', fontWeight: 600 }}>
                                            Insta Save
                                        </h6>
                                    </div>
                                </div>

                                <div style={{ width: '100%', padding: '24px', background: '#FFFFFF' }}>
                                    <p className='mb-3 pb-1' style={{ color: '#000000', fontSize: '12px', lineHeight: '14px', fontWeight: 600 }}>
                                        Disclaimer
                                    </p>
                                    <p className='mb-3' style={{ fontSize: '12px', lineHeight: '16px', fontWeight: 400 }}>
                                        Mutual fund investments are subject to market risks. Please read all scheme-related documents carefully before investing.
                                    </p>
                                    <p className='mb-3' style={{ fontSize: '12px', lineHeight: '16px', fontWeight: 400, }}>
                                        Mutual fund distribution services are offered through Goalhive Financial Services Private Limited, registered with AMFI as a Mutual Fund Distributor (ARN: 307650). Rayi is a brand of Goalhive Financial Services Private Limited.
                                    </p>
                                    <p className='mb-3' style={{ fontSize: '12px', lineHeight: '16px', fontWeight: 400, }}>
                                        All payments are processed by our technology service provider, Cybrilla, on behalf of Goalhive Financial Services Private Limited.
                                    </p>
                                    <p className='mb-0' style={{ fontSize: '12px', lineHeight: '16px', fontWeight: 400, }}>
                                        This is an auto-generated email. Please do not reply to this email.
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div >
        </div >
    )
}

export default ViewTemplateModal;
